<app-topnav></app-topnav>


<!-- HEADER -->
<app-header-secondary-g [pageTitle]="'offresemploi.title' | translate" 
[pageDescription]="'offresemploi.description' | translate"
[imageURL]="'assets/img/header/headerg-blob-emploi.png'"></app-header-secondary-g>
<!-- end HEADER -->

<div class="container">
    <p><a [routerLink]="['/offresemploi']"><i class="fa fa-arrow-left"></i>  {{ 'offresemploi.retourliste' | translate }}</a></p><hr>
</div>

<section id="section-offresemploi-detail">

<div class="container">
    <div *ngIf="currentLang ==='fr'" [innerHTML]="texte.FR"></div>
    <div *ngIf="currentLang ==='en'" [innerHTML]="texte.EN"></div>
</div>
<BR><BR>

</section>

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>